/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Stock_Movement_Sync_Not_RetryableInputs */

const en_error_stock_movement_sync_not_retryable = /** @type {(inputs: Error_Stock_Movement_Sync_Not_RetryableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The message cannot be sent again now: it is on its way, or the system already took it.`)
};

/**
* | output |
* | --- |
* | "The message cannot be sent again now: it is on its way, or the system already took it." |
*
* @param {Error_Stock_Movement_Sync_Not_RetryableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_stock_movement_sync_not_retryable = /** @type {((inputs?: Error_Stock_Movement_Sync_Not_RetryableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Stock_Movement_Sync_Not_RetryableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_stock_movement_sync_not_retryable(inputs)
});